import { ContentType, HttpClient, RequestParams } from '../http-client';

export class CrewLearning<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getCrewLearningEnrollmentsById = (
    id: string,
    query: {
      version: string;
    },
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/crew/learning/enrollments/${id}/courses/sections`,
      method: 'GET',
      secure: true,
      ...(query && { query }),
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCrewLearningEnrollments = (params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/crew/learning/v2/enrollments`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  updateCrewLearningSectionById = (
    id: number,
    payload: any,
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/crew/learning/enrollments/section/${id}`,
      method: 'PATCH',
      secure: true,
      body: payload,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  updateCrewLearningPathById = (
    id: number,
    payload: any,
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/crew/learning/enrollments/${id}`,
      method: 'PATCH',
      secure: true,
      body: payload,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
